import React from 'react';
import styled from 'styled-components';
import useTracking from '../Tracking/useTracking';

const PaginationWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px;
  a {color: ${p=>p.textColor||'white'};}
`;

const DisabledLink = styled.a `
  float: left;
  text-decoration: none;
  transition: background-color .3s;
  margin: 10px 20px;
  opacity: 0.5;
  &.mobileHide {
    @media (max-width: 650px) {
      display: none;
    }
  }

`;

const CurrentLink = styled(DisabledLink)
`
  opacity: 1;
  margin: 0 4px;
  padding: 8px 14px;
  border: 2px solid ${p=>p.borderColor||'white'};
  border-radius: 3px;
`;
const ActiveLink = styled(DisabledLink)
`
  opacity: 1;
  padding: 10px 16px;
  margin: 0 4px;
  border: '2px';
  :hover {
    padding: 8px 14px;
    border: 2px solid ${p=>p.borderColor||'white'};
    border-radius: 3px;
  }
`;

const Column = styled.div `
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.mobileShow {
    @media (max-width: 650px) {
      min-width: 100%;
    }
  }  
`;

const FakePagination = ({ textColor, borderColor, hoverColor }) => {
  const { trackAndRedirect } = useTracking();

  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
    let payload = { component: 'FakePagination' };
    trackAndRedirect(payload);
  };

  borderColor = borderColor || textColor || '#FFF';
  hoverColor = hoverColor || textColor || borderColor || '#FFF';

  return (
    <PaginationWrapper textColor={textColor}>
    <Column>
      <DisabledLink href="#" className="mobileHide" onClick={handleClick}>First</DisabledLink>
    </Column>
    <Column className="mobileShow">
      <DisabledLink href="#" onClick={handleClick}>&lt; Back</DisabledLink>
      <CurrentLink className="mobileHide" borderColor={borderColor} onClick={handleClick}>1</CurrentLink>
      <ActiveLink href='#' className="mobileHide" borderColor={hoverColor} onClick={handleClick}>2</ActiveLink>
      <ActiveLink href="#" className="mobileHide" borderColor={hoverColor} onClick={handleClick}>3</ActiveLink>
      <ActiveLink href="#" className="mobileHide" borderColor={hoverColor} onClick={handleClick}>4</ActiveLink>
      <ActiveLink href="#" className="mobileHide" borderColor={hoverColor} onClick={handleClick}>5</ActiveLink>
      <ActiveLink href="#" borderColor={hoverColor} onClick={handleClick}>Next &gt;</ActiveLink>
    </Column>
    <Column>
      <ActiveLink href="#" className="mobileHide" borderColor={hoverColor} onClick={handleClick}>Last</ActiveLink>
    </Column>
    </PaginationWrapper>
  );
};

export default FakePagination;
